<template>
  <div>
    <div class="sm:border-b sm:border-gray-400 sm:pb-5 sm:mb-5">
      <h3 class="text-lg leading-6 font-semibold text-blue-600">Delivery</h3>
    </div>
    <dl class="sm:divide-y sm:divide-gray-200">
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">Shipped At</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shippedAt ? _date(shippedAt) : 'NA' }}
        </dd>
      </div>
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">Name</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shipping.first_name || '' }} {{ shipping.last_name || '' }}
        </dd>
      </div>
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">Street 1</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shipping.street_1 || '-' }}
        </dd>
      </div>
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">Street 2</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shipping.street_2 || '-' }}
        </dd>
      </div>
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">City</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shipping.city || '-' }}
        </dd>
      </div>
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">State</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shipping.state || '-' }}
        </dd>
      </div>
      <div class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-2">
        <dt class="text-sm font-medium text-blue-600">Zip</dt>
        <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
          {{ shipping.zip || '-' }}
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
// import _datetime from "@/Filters/DateTime";
import _date from '@/Filters/Date'

export default {
  props: {
    shipping: {
      type: Object,
      required: true
    },
    shippedAt: {
      type: String,
      default: null
    }
  },

  methods: {
    _date
  }
}
</script>
